// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './ResizableEditorOverflowOverlay.scss';

const ResizableEditorOverflowOverlay = ({ show }) => (
    <div className={classNames('ResizableEditorOverflowOverlay', { show })} />
);

ResizableEditorOverflowOverlay.propTypes = {
    show: PropTypes.bool,
};

export default ResizableEditorOverflowOverlay;
